/**
 * Color mode (DEV-12394): the avatar-menu appearance selector.
 *
 * The theme attribute is SERVER-rendered on <html> (page.tpl) so there is
 * no flash of the wrong theme; this module only handles live switching from the segmented
 * control in the profile menu and persisting the choice to contacts.color_mode.
 *
 * Modes: 'light' | 'dark' are explicit user picks; 'auto' means "inherit the instance
 * default" (settings.default_color_mode, exposed on the row as data-instance-default).
 * NOTE 'auto' does NOT mean follow-OS — OS auto-dark stays disabled until the M3 element
 * migration completes (see the deviation note in styles/scss/m3/_tokens.scss).
 */
// The leading semicolon is load-bearing: this file is concatenated into the js bundles,
// and if the previous file ends in an unterminated expression, a bare ( would turn it
// into a call of that expression.
;(function () {
	'use strict';

	function resolveTheme(row, mode) {
		if (mode === 'auto')
			return row.getAttribute('data-instance-default') === 'dark' ? 'dark' : 'light';
		return mode === 'dark' ? 'dark' : 'light';
	}

	function setPressed(segs, mode) {
		segs.forEach(function (b) {
			b.setAttribute('aria-pressed', b.getAttribute('data-set-color-mode') === mode ? 'true' : 'false');
		});
	}

	function apply(row, segs, mode) {
		setPressed(segs, mode);
		document.documentElement.setAttribute('data-theme', resolveTheme(row, mode));
	}

	function init() {
		var row = document.getElementById('color_mode');
		if (!row) return;
		var segs = Array.prototype.slice.call(row.querySelectorAll('[data-set-color-mode]'));
		if (!segs.length) return;

		segs.forEach(function (btn) {
			btn.addEventListener('click', function () {
				var mode = btn.getAttribute('data-set-color-mode');
				var previous = row.getAttribute('data-color-mode') || 'auto';
				if (mode === previous) return;

				apply(row, segs, mode); // optimistic: flip immediately, no reload
				row.setAttribute('data-color-mode', mode);

				am.$.ajax({
					url: '/ajax/update_contact_color_mode/',
					type: 'POST',
					dataType: 'json', // the ajax.php dispatcher sends application/json for every route
					data: { mode: mode },
					success: function (data) {
						if (!data || data.status !== 200) { fail(data && data.message); return; }
						// DEV-12911: the server just mirrored the theme to the MFE
						// user-data service, but the React apps read settings through
						// a sessionStorage cache (4h TTL) that only a same-origin
						// BroadcastChannel message invalidates — a message the SDK's
						// own writers post and a server-side PATCH cannot. Post the
						// wholesale clear ('settings-cleared', no appKey: per-app
						// merged caches embed the global theme, so a scoped 'global'
						// message would not refresh them). Reaches the embed iframes
						// AND other tabs; browsers without BroadcastChannel just wait
						// out the TTL.
						try {
							new BroadcastChannel('allmoxy-settings').postMessage({ type: 'settings-cleared' });
						} catch (e) { /* optional enhancement only */ }
					},
					error: function () { fail(null); }
				});

				function fail(message) {
					apply(row, segs, previous); // roll the UI back to the last saved mode
					row.setAttribute('data-color-mode', previous);
					if (typeof show_snackbar === 'function')
						show_snackbar({ message: message || 'Something went wrong. Please try again.', type: 'danger' });
				}
			});
		});
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
	else init();
})();
